import script from "./BusinessGrowthTrend.vue?vue&type=script&setup=true&lang=js"
export * from "./BusinessGrowthTrend.vue?vue&type=script&setup=true&lang=js"

import "./BusinessGrowthTrend.vue?vue&type=style&index=0&id=d5a64986&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d5a64986"]])

export default __exports__